import { Component, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MdSnackBar } from '@angular/material';

import { TdLoadingService, TdDialogService, TdMediaService } from '@covalent/core';

import { StorageService } from '../services/storage.service';

import 'rxjs/add/operator/toPromise';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/security/authentication.service';

@Component({
  selector: 'stockup',
  providers: [StorageService],
  templateUrl: './stockup.component.html',
  styleUrls: ['./stockup.component.scss']
})
export class StockupComponent {

  storages: any[] = [];
  filteredStorages: any[];
  filterTitle: string;
  filterString: string = '';
  countryCode: string;


  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _storageService: StorageService,
    private _router: Router,
    private _dialogService: TdDialogService,
    private _snackBarService: MdSnackBar,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService,
    private _authenticationService: AuthenticationService) {

    const storageName = this._authenticationService.getStorageName();
    this.countryCode = storageName.substring(0, 2);
  }

 

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/stockUp/stockup.component.ts